import Button from '@ixigo/iui/Button';
import Typography from '@ixigo/iui/Typography';
import { FC } from 'react';
import { ErrorSectionProps } from './index.types';

const ErrorSection: FC<ErrorSectionProps> = ({ onClickRetry, sectionName }) => {
    const onRetryHandler = () => {
        if (onClickRetry) onClickRetry(true);
    };

    const message = `Unfortunately, ${sectionName} section is currently unavailable!
        ${onClickRetry ? 'Please use the retry option or try again later.' : 'Please try again later'}`;

    return (
        <div className='flex flex-col items-center justify-between gap-10 px-20 py-40 bg-white'>
            <div className='flex flex-col items-center justify-center gap-1'>
                <Typography variant='h5' fontWeight='medium'>
                    Uh oh!
                </Typography>
                <Typography variant='body-sm' fontWeight='normal' className='text-center'>
                    {message}
                </Typography>
            </div>
            {onClickRetry && (
                <div className='flex flex-col'>
                    <Button variant='flat' size='lg' onClick={onRetryHandler}>
                        Retry
                    </Button>
                </div>
            )}
        </div>
    );
};

export default ErrorSection;
